import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { H2 } from 'UIComponents/elements/headings';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import WorkflowCampaignSelect from 'campaigns-lib/components/campaignSelect/WorkflowCampaignSelect';
import { useGetHasScope } from 'automation-ui-core/hooks/authHooks';
import * as Scopes from 'automation-ui-canvas/constants/Scopes';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import { updateCampaignAssociations } from 'automation-ui-canvas/data/api/campaignAssociationApi';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { getWorkflowId } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SelectCampaignModal = ({
  flow,
  onClose
}) => {
  const hasScope = useGetHasScope();
  const [campaignIds, setCampaignIds] = useState([]);
  const workflowId = getWorkflowId(flow);
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.editorMenuBar.options.campaign.label"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(WorkflowCampaignSelect, {
        assetId: workflowId,
        onError: () => {},
        formControlProps: {
          error: false,
          validationMessage: null,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.editorMenuBar.options.campaign.description"
          }),
          FormLabel: 'span'
        },
        onMount: initialCampaigns => {
          setCampaignIds(initialCampaigns);
        },
        onChange: ({
          target: {
            value: updatedCampaigns
          }
        }) => {
          setCampaignIds(updatedCampaigns);
        },
        selectProps: {
          error: false,
          readOnly: false,
          className: ''
        },
        hasCampaignsReadAccess: hasScope(Scopes.CAMPAIGNS_ACCESS),
        hasCampaignsWriteAccess: hasScope(Scopes.CAMPAIGNS_WRITE)
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: () => {
          updateCampaignAssociations(workflowId, campaignIds).then(() => {
            onClose();
          }).catch(() => {});
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.save"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.cancel"
        })
      })]
    })]
  });
};